export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_GOOGLE_REQUEST = "AUTH_GOOGLE_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_FORGOT_PASSWORD = "AUTH_FORGOT_PASSWORD";
export const AUTH_REFRESH_TOKEN = "AUTH_REFRESH_TOKEN";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const AUTH_RESET_PASSWORD = "AUTH_RESET_PASSWORD";
export const CHATBOT_CONVERSATION = "CHATBOT_CONVERSATION"
